import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export default ({ children, ...props }) => {
    

    return (
        <Style {...props}>
            { children }
        </Style>
    )
}


const Style = styled.section.attrs(props => ({
    className: 'section'
}))`
    padding-top: var(--gutter);
    padding-bottom: var(--gutter);
    overflow: hidden;

    > header {
        text-align: center;

        > h2 {
            font-size: 5.5vmax;
            line-height: 1;
            letter-spacing: -.0375em;
            margin: 0;
            font-weight: 800;


            ${breakpoint('desktop')`
                font-size: 67px;
            `}
        }

        > strong {
            font-size: 4.05vmax;
            display: block;
            margin-bottom: 1em;
            font-weight: 600;
            line-height: 1;
            letter-spacing: -1.12px;

            ${breakpoint('desktop')`
                font-size: 32px;
            `}
        }


        > p {
            font-size: 18px;
            line-height: 1.3;
        }
    }


    .section__list-set {
        display: flex;
        flex-direction: column;

        ${breakpoint('tablet')`
            flex-direction: row;
        `}

        > div {
            flex: 1;
            order: 1;
            margin-bottom: 5vh;
            
            ${breakpoint('tablet')`
                margin: 2vh 0 3vh 0;
            `}

            + div {
                order: 3;
            } 
        }

        > figure {
            order: 2;
            flex: 1.35;
            margin: 0 2vw -180px 2vw;
            max-height: 400px;
            display: none;
            align-items: flex-start;
            justify-content: center;

            ${breakpoint('tablet')`
                display: flex;
            `}

            img {
                margin-bottom: 0;
                object-position: top!important;
            }
        }
    }

`